import React, { useState, useRef } from "react";
import {
  Flex,
  Button,
  Text,
  Modal,
  Center,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import { FieldErrors, FieldValues, UseFormGetValues } from "react-hook-form";
import AvatarEditor from "react-avatar-editor";
import { IoClose } from "react-icons/io5";

type FileUploderProps = {
  errors: FieldErrors<FieldValues>;
  register: any;
  getValues: UseFormGetValues<any>;
  coverPageImg: any;
  setCoverPageImg: any;
};

const FileUploader: React.FC<FileUploderProps> = ({
  coverPageImg,
  setCoverPageImg,
  errors,
  register,
  getValues,
}) => {
  const editorRef = useRef<AvatarEditor | null>(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [filename, setFilename] = useState<string | undefined>("");

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null;
    setFilename(file?.name);
    setCoverPageImg(file);
    onOpen();
  };

  const handleUpload = async () => {
    if (editorRef.current) {
      const canvas = editorRef.current.getImageScaledToCanvas();
      canvas.toBlob(async (blob: any) => {
        if (blob) {
          blob.name = filename;
          setCoverPageImg(blob);
          onClose();
        }
      });
    }
  };

  return (
    <Flex
      direction="column"
      alignItems="center"
      sx={{ w: ["100%", "100%", "100%", "200px"] }}
    >
      <Button
        as={"label"}
        htmlFor={"headshot"}
        variant={"outline"}
        colorScheme={"teal"}
        w="auto"
        onClick={onOpen}
      >
        Upload Project Headshot
      </Button>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Crop and Upload Image</ModalHeader>
          <ModalCloseButton />
          <ModalBody
            sx={{ display: "flex", flexDir: "column", alignItems: "center" }}
          >
            <input type="file" onChange={handleFileChange} />
            {coverPageImg && (
              <AvatarEditor
                ref={editorRef}
                image={coverPageImg}
                style={{ width: "250px", height: "250px" }}
                width={1000}
                height={1000}
                border={50}
              />
            )}
          </ModalBody>
          {coverPageImg && (
            <Center sx={{ my: ["10px"] }}>
              <Button
                sx={{
                  bgColor: "#FFAF7A",
                  w: ["100px"],
                  borderRadius: ["50px"],
                }}
                onClick={handleUpload}
              >
                Confirm
              </Button>
            </Center>
          )}
        </ModalContent>
      </Modal>
      {coverPageImg && (
        <Flex
          sx={{ alignItems: "center", justifyContent: "center", gap: ["50px"] }}
        >
          <Text> {filename}</Text>
          <IoClose
            color="#FFAF7A"
            onClick={() => {
              setCoverPageImg(null);
            }}
            cursor="pointer"
          />
        </Flex>
      )}
    </Flex>
  );
};

export default FileUploader;
